import { render, staticRenderFns } from "./new_trusteeshio_msg.vue?vue&type=template&id=3d2f81fb&scoped=true&"
import script from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
export * from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeshio_msg.vue?vue&type=style&index=0&id=3d2f81fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f81fb",
  null
  
)

export default component.exports